module.exports = __webpack_public_path__ + "static/media/katheryn-winnick-lose.ff7071d1.jpg";